document.addEventListener('DOMContentLoaded', function() {
  // 1) Aplica cursor em todos os slides com link
  document.querySelectorAll('.slideshow__slide[data-slide-url]')
    .forEach(slide => slide.style.cursor = 'pointer');

  // 2) Delegação de clique: qualquer clique dentro de um slide
  document.body.addEventListener('click', function(event) {
    // Encontra o .slideshow__slide mais próximo, se tiver dataset
    var slide = event.target.closest('.slideshow__slide[data-slide-url]');
    if (!slide) return;

    // Se o clique foi num <a> interno (botão, link de texto...), aborta
    if (event.target.closest('a')) return;

    // Senão redireciona
    var url = slide.dataset.slideUrl;
    if (url) window.location.href = url;
  });
});
